<app-post-item [post]="postsStore.selectedPost$|async"
               (vote)="vote($event)" (deletePosts)="delete()">
</app-post-item>
